import { render, staticRenderFns } from "./order-delivery-log.vue?vue&type=template&id=2fa56ae3"
import script from "./order-delivery-log.vue?vue&type=script&lang=js"
export * from "./order-delivery-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports